import React from "react";
import styled from "@emotion/styled";

const StyledLogo = styled.g`
  color: ${({ theme }) => theme.header};
`;

const StyledFrame = styled.g`
  color: ${({ theme }) => theme.header};
`;

const LogoMobile = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 346.5 306.5">
      <StyledLogo id="Logo" fill="currentColor">
        <path
          className="cls-1"
          d="M31.18,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,38.71v-14H45V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M79,30.37v8.34h-.88V31.25H74.37v-.88Zm-1.76,1.76v6.58h-.88V33h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,38.71v-14H117V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M132,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M143.77,30.37v8.34h-.88V31.25h-3.74v-.88ZM142,32.13v6.58h-.88V33h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M160.74,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M194.15,30.37v8.34h-.88V31.25h-3.74v-.88Zm-1.76,1.76v6.58h-.88V33h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M203.93,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M218.32,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M239.92,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M247.11,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M254.31,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M266.13,30.37v8.34h-.88V31.25h-3.74v-.88Zm-1.76,1.76v6.58h-.88V33h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,38.71v-14h6.59V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M287.72,30.37v8.34h-.88V31.25H283.1v-.88ZM286,32.13v6.58h-.88V33h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,38.71v-14h6.6V38.71Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M323.71,30.37v8.34h-.88V31.25h-3.74v-.88ZM322,32.13v6.58h-.88V33h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,53.12V39.06H45V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.18,44.77v.88H48.44v7.47h-.88V44.77Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,44.77h6.59v.88H52.78Zm0,1.76h6.59v.88H52.78Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,44.77h6.6v.88H60Zm0,1.76h6.6v.88H60Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,53.12V39.06H81V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M86.19,44.77v8.35h-.88V45.65H81.57v-.88Zm-1.76,1.76v6.59h-.88V47.41h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,53.12V39.06h6.59V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M109.76,44.77v.88H106v7.47h-.88V44.77Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,44.77H117v.88h-6.6Zm0,1.76H117v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,44.77h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,44.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M132,44.77h6.6v.88H132Zm0,1.76h6.6v.88H132Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M139.15,47.41v-.88h3.74V39.06h.88v8.35ZM142,45.65h-2.86v-.88h2V39.06H142Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,53.12V39.06h6.59V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.34,44.77v.88H163.6v7.47h-.88V44.77Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,44.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,44.77h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M201.35,44.77v8.35h-.88V45.65h-3.74v-.88Zm-1.76,1.76v6.59h-.88V47.41h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M205.91,47.41V39.06h.88v7.47h3.74v.88Zm1.76-1.76V39.06h.87v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,44.77h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M218.32,44.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M246.51,44.77v.88h-3.73v7.47h-.88V44.77Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M247.11,44.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M254.31,44.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M261.51,47.41v-.88h3.74V39.06h.88v8.35Zm2.86-1.76h-2.86v-.88h2V39.06h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,53.12V39.06h6.59V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M285.08,39.06H286V53.12h-.88Zm1.76,14.06V39.06h.88V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,53.12V39.06h6.6V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M321.07,39.06H322V53.12h-.88Zm1.76,14.06V39.06h.88V53.12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,67.51V53.46H45V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M47.56,53.46h.88V67.51h-.88Zm1.76,14.05V53.46h.88V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,67.51V53.46H81V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M83.55,53.46h.88V67.51h-.88Zm1.76,14.05V53.46h.88V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,67.51V53.46h6.59V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,67.51V53.46H117V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,67.51V53.46h6.59V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M129.37,59.17v8.34h-.88V60.05h-3.74v-.88Zm-1.76,1.76v6.58h-.88v-5.7h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,67.51V53.46h6.59V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M160.74,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,67.51V53.46h6.59V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M198.71,53.46h.88V67.51h-.88Zm1.76,14.05V53.46h.88V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M241.9,53.46h.88V67.51h-.88Zm1.75,14.05V53.46h.88V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,67.51V53.46h6.59V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,67.51V53.46h6.6V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M321.07,53.46H322V67.51h-.88Zm1.76,14.05V53.46h.88V67.51Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,81.92V67.86H45V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M47.56,67.86h.88V81.92h-.88Zm1.76,14.06V67.86h.88V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,81.92V67.86H81V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M83.55,67.86h.88V81.92h-.88Zm1.76,14.06V67.86h.88V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,81.92V67.86h6.59V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M109.76,73.57v.88H106v7.47h-.88V73.57Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,73.57H117v.88h-6.6Zm0,1.76H117v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,73.57h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,76.21v-.88h3.74V67.86h.88v8.35Zm2.86-1.76h-2.86v-.88h2V67.86h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,81.92V67.86h6.59V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.34,73.57v.88H163.6v7.47h-.88V73.57Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,73.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,73.57h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M198.71,67.86h.88V81.92h-.88Zm1.76,14.06V67.86h.88V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M241.9,67.86h.88V81.92h-.88Zm1.75,14.06V67.86h.88V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,81.92V67.86h6.59V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M289.7,73.57v.88H286v7.47h-.88V73.57Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,73.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,73.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,81.92V67.86h6.6V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M321.07,67.86H322V81.92h-.88Zm1.76,14.06V67.86h.88V81.92Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,96.32V82.26H45V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,96.32V82.26h6.59V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M81,88v.88H77.23v7.47h-.88V88Zm-2.86,1.76H81v.88H79v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M81.57,90.61v-.88h3.74V82.26h.88v8.35Zm2.86-1.76H81.57V88h2V82.26h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,96.32V82.26h6.59V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,96.32V82.26H117V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,96.32V82.26h6.59V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M132,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M143.77,88v8.35h-.88V88.85h-3.74V88ZM142,89.73v6.59h-.88V90.61h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,96.32V82.26h6.59V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M162.72,82.26h.88V96.32h-.88Zm1.76,14.06V82.26h.88V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M198.71,82.26h.88V96.32h-.88Zm1.76,14.06V82.26h.88V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M241.9,82.26h.88V96.32h-.88Zm1.75,14.06V82.26h.88V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,96.32V82.26h6.59V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M285.08,82.26H286V96.32h-.88Zm1.76,14.06V82.26h.88V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,96.32V82.26h6.6V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M321.07,82.26H322V96.32h-.88Zm1.76,14.06V82.26h.88V96.32Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M33.16,105V96.66H34v7.47h3.74V105Zm1.76-1.76V96.66h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,102.37H45v.88h-6.6Zm0,1.76H45V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,102.37h6.59v.88H52.78Zm0,1.76h6.59V105H52.78Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,102.37h6.6v.88H60Zm0,1.76h6.6V105H60Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,105v-.88h3.74V96.66H79V105Zm2.86-1.76H74.37v-.88h2V96.66h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M90.75,105V96.66h.87v7.47h3.74V105Zm1.75-1.76V96.66h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,102.37h6.6v.88H96Zm0,1.76h6.6V105H96Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,102.37H117v.88h-6.6Zm0,1.76H117V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,102.37h6.59v.88h-6.59Zm0,1.76h6.59V105h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M132,102.37h6.6v.88H132Zm0,1.76h6.6V105H132Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M139.15,105v-.88h3.74V96.66h.88V105Zm2.86-1.76h-2.86v-.88h2V96.66H142Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M148.33,105V96.66h.88v7.47h3.73V105Zm1.75-1.76V96.66H151v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M160.74,105v-.88h3.74V96.66h.88V105Zm2.86-1.76h-2.86v-.88h2V96.66h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M184.32,105V96.66h.87v7.47h3.74V105Zm1.75-1.76V96.66H187v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M196.73,105v-.88h3.74V96.66h.88V105Zm2.86-1.76h-2.86v-.88h2V96.66h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M227.5,105V96.66h.88v7.47h3.74V105Zm1.76-1.76V96.66h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M239.92,105v-.88h3.73V96.66h.88V105Zm2.86-1.76h-2.86v-.88h2V96.66h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M270.69,105V96.66h.88v7.47h3.73V105Zm1.75-1.76V96.66h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,105v-.88h3.74V96.66h.88V105Zm2.86-1.76H283.1v-.88h2V96.66H286Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M306.68,105V96.66h.87v7.47h3.74V105Zm1.75-1.76V96.66h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,102.37h6.6v.88h-6.6Zm0,1.76h6.6V105h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M319.09,105v-.88h3.74V96.66h.88V105Zm2.86-1.76h-2.86v-.88h2V96.66H322Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,129.71V115.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,129.71V115.66H45v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M50.2,121.37v8.34h-.88v-7.46H45.58v-.88Zm-1.76,1.76v6.58h-.88V124h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,129.71V115.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,129.71V115.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,129.71V115.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M79,121.37v8.34h-.88v-7.46H74.37v-.88Zm-1.76,1.76v6.58h-.88V124h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,129.71V115.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,129.71V115.66H117v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M122.17,121.37v8.34h-.88v-7.46h-3.73v-.88Zm-1.75,1.76v6.58h-.88V124h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,144.12V130.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,144.12V130.06H45v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M47.56,130.06h.88v14.06h-.88Zm1.76,14.06V130.06h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,144.12V130.06h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,144.12V130.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,144.12V130.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,144.12V130.06H81v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M86.19,135.77v8.35h-.88v-7.47H81.57v-.88Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,144.12V130.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,144.12V130.06H117v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M119.54,130.06h.88v14.06h-.88Zm1.75,14.06V130.06h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,158.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,158.51v-14H45v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M47.56,144.46h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,158.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,158.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M73.77,150.17v.88H70v7.46h-.88v-8.34Zm-2.86,1.76h2.86v.88h-2v5.7h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,158.51v-14H81v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M81.57,158.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M93.38,150.17v8.34H92.5v-7.46H88.77v-.88Zm-1.76,1.76v6.58h-.87v-5.7h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,158.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,158.51v-14H117v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M119.54,144.46h.88v14h-.88Zm1.75,14v-14h.88v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,172.92V158.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,172.92V158.86H45v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M47.56,158.86h.88v14.06h-.88Zm1.76,14.06V158.86h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,172.92V158.86h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,172.92V158.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M69.15,158.86H70v14.06h-.88Zm1.76,14.06V158.86h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M76.35,167.21v-8.35h.88v7.47H81v.88Zm1.76-1.76v-6.59H79v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M81.57,172.92V158.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,172.92V158.86h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M100.58,164.57v8.35H99.7v-7.47H96v-.88Zm-1.76,1.76v6.59h-.88v-5.71H96v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,172.92V158.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,172.92V158.86H117v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M119.54,158.86h.88v14.06h-.88Zm1.75,14.06V158.86h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,187.32V173.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,187.32V173.26H45v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M47.56,173.26h.88v14.06h-.88Zm1.76,14.06V173.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,187.32V173.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,187.32V173.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M69.15,173.26H70v14.06h-.88Zm1.76,14.06V173.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M83.55,181.61v-8.35h.88v7.47h3.74v.88Zm1.76-1.76v-6.59h.88V179h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,187.32V173.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,187.32V173.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,187.32V173.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,187.32V173.26H117v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M119.54,173.26h.88v14.06h-.88Zm1.75,14.06V173.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M33.16,196v-8.35H34v7.47h3.74V196Zm1.76-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,193.37H45v.88h-6.6Zm0,1.76H45V196h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,196v-.88h3.74v-7.47h.88V196Zm2.86-1.76H45.58v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M54.76,196v-8.35h.88v7.47h3.73V196Zm1.76-1.76v-6.59h.87v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,193.37h6.6v.88H60Zm0,1.76h6.6V196H60Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,196v-.88h3.74v-7.47h.88V196ZM70,194.25H67.17v-.88h2v-5.71H70Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M90.75,196v-8.35h.87v7.47h3.74V196Zm1.75-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,193.37h6.6v.88H96Zm0,1.76h6.6V196H96Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,193.37h6.6v.88h-6.6Zm0,1.76h6.6V196h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,193.37H117v.88h-6.6Zm0,1.76H117V196h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,196v-.88h3.73v-7.47h.88V196Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,220.71V206.66H45v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,220.71V206.66H81v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M86.19,212.37v8.34h-.88v-7.46H81.57v-.88Zm-1.76,1.76v6.58h-.88V215h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,220.71V206.66H117v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M136.57,212.37v8.34h-.88v-7.46H132v-.88Zm-1.76,1.76v6.58h-.88V215h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M160.74,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M194.15,212.37v8.34h-.88v-7.46h-3.74v-.88Zm-1.76,1.76v6.58h-.88V215h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M218.32,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M239.92,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M247.11,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M258.93,212.37v8.34h-.88v-7.46h-3.74v-.88Zm-1.76,1.76v6.58h-.88V215h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M261.51,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,220.71V206.66h6.59v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,220.71V206.66h6.6v14.05Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M316.51,212.37v8.34h-.88v-7.46h-3.74v-.88Zm-1.76,1.76v6.58h-.88V215h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,235.12V221.06H45v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.18,226.77v.88H48.44v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,226.77h6.59v.88H52.78Zm0,1.76h6.59v.88H52.78Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,226.77h6.6v.88H60Zm0,1.76h6.6v.88H60Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,226.77H81v.88h-6.6Zm0,1.76H81v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M81.57,229.41v-.88h3.74v-7.47h.88v8.35Zm2.86-1.76H81.57v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,235.12V221.06h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M109.76,226.77v.88H106v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,226.77H117v.88h-6.6Zm0,1.76H117v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,226.77h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M132,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M143.77,226.77v8.35h-.88v-7.47h-3.74v-.88ZM142,228.53v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,235.12V221.06h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.34,226.77v.88H163.6v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,226.77h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M201.35,226.77v8.35h-.88v-7.47h-3.74v-.88Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M203.93,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,235.12V221.06h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M224.92,226.77v.88h-3.74v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M239.92,226.77h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M247.11,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M254.31,229.41v-.88h3.74v-7.47h.88v8.35Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M261.51,235.12V221.06h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,235.12V221.06h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M282.5,226.77v.88h-3.74v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,226.77h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,229.41v-.88h3.74v-7.47h.88v8.35Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,249.51v-14H45v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,249.51v-14H81v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M86.19,241.17v8.34h-.88v-7.46H81.57v-.88Zm-1.76,1.76v6.58h-.88v-5.7h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,249.51v-14H117v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M138.55,241.17v.88h-3.74v7.46h-.88v-8.34Zm-2.86,1.76h2.86v.88h-2v5.7h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M139.15,243.81v-.88h3.74v-7.47h.88v8.35Zm2.86-1.76h-2.86v-.88h2v-5.71H142Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M160.74,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M198.71,235.46h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M203.93,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M220.3,235.46h.88v14h-.88Zm1.76,14v-14h.88v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M261.51,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,249.51v-14h6.59v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,249.51v-14h6.6v14Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M302.11,241.17v8.34h-.87v-7.46H297.5v-.88Zm-1.75,1.76v6.58h-.88v-5.7h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M33.16,258.21v-8.35H34v7.47h3.74v.88Zm1.76-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,255.57H45v.88h-6.6Zm0,1.76H45v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,255.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,255.57h6.59v.88H52.78Zm0,1.76h6.59v.88H52.78Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,255.57h6.6v.88H60Zm0,1.76h6.6v.88H60Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,263.92V249.86H81v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M83.55,249.86h.88v14.06h-.88Zm1.76,14.06V249.86h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,263.92V249.86h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M109.76,255.57v.88H106v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M110.36,255.57H117v.88h-6.6Zm0,1.76H117v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M117.56,255.57h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M124.75,255.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M132,258.21v-.88h3.74v-7.47h.88v8.35Zm2.86-1.76H132v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,263.92V249.86h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.34,255.57v.88H163.6v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M167.94,255.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M175.14,255.57h6.59v.88h-6.59Zm0,1.76h6.59v.88h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M198.71,249.86h.88v14.06h-.88Zm1.76,14.06V249.86h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M203.93,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,263.92V249.86h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M220.3,249.86h.88v14.06h-.88Zm1.76,14.06V249.86h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M261.51,263.92V249.86h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,263.92V249.86h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M282.5,255.57v.88h-3.74v7.47h-.88v-8.35Zm-2.86,1.76h2.86v.88h-2v5.71h-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,255.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,255.57h6.6v.88h-6.6Zm0,1.76h6.6v.88h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,258.21v-.88h3.74v-7.47h.87v8.35Zm2.86-1.76H297.5v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M31.18,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,278.32V264.26H45v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,278.32V264.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,278.32V264.26H81v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M83.55,264.26h.88v14.06h-.88Zm1.76,14.06V264.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M88.77,278.32V264.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M105.14,264.26H106v14.06h-.88Zm1.76,14.06V264.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M146.35,278.32V264.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M162.72,264.26h.88v14.06h-.88Zm1.76,14.06V264.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M182.33,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M198.71,264.26h.88v14.06h-.88Zm1.76,14.06V264.26h.88v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M205.91,272.61v-8.35h.88v7.47h3.74v.88Zm1.76-1.76v-6.59h.87V270h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M211.13,278.32V264.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M218.32,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M239.92,278.32V264.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M247.11,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M258.93,270v8.35h-.88v-7.47h-3.74V270Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M261.51,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,278.32V264.26h6.59v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,278.32V264.26h6.6v14.06Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M316.51,270v8.35h-.88v-7.47h-3.74V270Zm-1.76,1.76v6.59h-.88v-5.71h-2v-.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M33.16,287v-8.35H34v7.47h3.74V287Zm1.76-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M38.38,284.37H45v.88h-6.6Zm0,1.76H45V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M45.58,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M52.78,284.37h6.59v.88H52.78Zm0,1.76h6.59V287H52.78Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M60,284.37h6.6v.88H60Zm0,1.76h6.6V287H60Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M67.17,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M74.37,284.37H81v.88h-6.6Zm0,1.76H81V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M81.57,287v-.88h3.74v-7.47h.88V287Zm2.86-1.76H81.57v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M90.75,287v-8.35h.87v7.47h3.74V287Zm1.75-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M96,284.37h6.6v.88H96Zm0,1.76h6.6V287H96Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M103.16,287v-.88h3.74v-7.47h.88V287Zm2.86-1.76h-2.86v-.88h2v-5.71H106Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M148.33,287v-8.35h.88v7.47h3.73V287Zm1.75-1.76v-6.59H151v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M153.54,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M160.74,287v-.88h3.74v-7.47h.88V287Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M184.32,287v-8.35h.87v7.47h3.74V287Zm1.75-1.76v-6.59H187v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M189.53,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M196.73,287v-.88h3.74v-7.47h.88V287Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M213.11,287v-8.35H214v7.47h3.74V287Zm1.75-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M218.32,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M225.52,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M232.72,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M239.92,284.37h6.59v.88h-6.59Zm0,1.76h6.59V287h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M247.11,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M254.31,287v-.88h3.74v-7.47h.88V287Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M263.49,287v-8.35h.88v7.47h3.74V287Zm1.76-1.76v-6.59h.88v5.71h2v.88Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M268.71,284.37h6.59v.88h-6.59Zm0,1.76h6.59V287h-6.59Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M275.9,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M283.1,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M290.3,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M297.5,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M304.69,284.37h6.6v.88h-6.6Zm0,1.76h6.6V287h-6.6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-1"
          d="M311.89,287v-.88h3.74v-7.47h.88V287Zm2.86-1.76h-2.86v-.88h2v-5.71h.88Z"
          transform="translate(-3 -1.45)"
        />
      </StyledLogo>
      <StyledFrame id="Frame" fill={"currentColor"}>
        <path
          className="cls-2"
          d="M4.5,12v-1.5H3V9H4.5V4.45H3V3H4.5V1.45h3V3H9V1.45h3V3h1.5v1.5H12V9h1.5v1.5H12V12H9v-1.5H7.5V12Zm3-3H9V4.45H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M28.5,12v-1.5H27V9h1.5V4.45H27V3h1.5V1.45h3V3H33V1.45h3V3h1.5v1.5H36V9h1.5v1.5H36V12H33v-1.5H31.5V12Zm3-3H33V4.45H31.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M51,12V4.45h1.5V3H54V1.45h4.5V3H60v1.5h1.5V12h-3V9H54v3Zm3-4.5h4.5v-3H57V3H55.5v1.5H54Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M78,12v-1.5H76.5V9H75V4.45h1.5V3H78V1.45h6V3h1.5v1.5h-3V3h-3v1.5H78V9h1.5v1.5h3V9h3v1.5H84V12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M87,12V1.45h3V6h4.5V1.45h3V12h-3V7.45H90V12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M99,12V4.45h1.5V3H102V1.45h4.5V3H108v1.5h1.5V12h-3V9H102v3Zm3-4.5h4.5v-3H105V3h-1.5v1.5H102Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M111,12V1.45h9V3h1.5v4.5h-3V9H120v1.5h1.5V12H117v-1.5h-1.5V9H114v3Zm3-4.5h3V6h1.5V3H114Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M123,12V4.45h1.5V3H126V1.45h4.5V3H132v1.5h1.5V12h-3V9H126v3Zm3-4.5h4.5v-3H129V3h-1.5v1.5H126Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M138,12v-1.5h-1.5V9H135V4.45h1.5V3H138V1.45h6V3h1.5v1.5h-3V3h-3v1.5H138V9h1.5v1.5h3V9h3v1.5H144V12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M151.5,12V3h-3V1.45h9V3h-3v9Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M159,12V1.45h10.5V3H162V6h6v1.5h-6v3h7.5V12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M171,12V1.45h9V3h1.5v4.5h-3V9H180v1.5h1.5V12H177v-1.5h-1.5V9H174v3Zm3-4.5h3V6h1.5V3H174Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M198,12v-1.5h-1.5V9H195V4.45h1.5V3H198V1.45h7.5V3h-6v1.5H198V9h1.5v1.5h3v-3H201V6h4.5v6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M207,12V1.45h10.5V3H210V6h6v1.5h-6v3h7.5V12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M219,12V1.45h3V3h1.5v1.5H225V6h1.5V1.45h3V12h-3V9H225V7.45h-1.5V6H222v6Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M231,12V1.45h10.5V3H234V6h6v1.5h-6v3h7.5V12Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M243,12V1.45h9V3h1.5v4.5h-3V9H252v1.5h1.5V12H249v-1.5h-1.5V9H246v3Zm3-4.5h3V6h1.5V3H246Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M255,12V4.45h1.5V3H258V1.45h4.5V3H264v1.5h1.5V12h-3V9H258v3Zm3-4.5h4.5v-3H261V3h-1.5v1.5H258Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M271.5,12V3h-3V1.45h9V3h-3v9Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M280.5,12v-1.5H279V3h1.5V1.45H288V3h1.5v7.5H288V12Zm1.5-1.5h4.5V3H282Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M291,12V1.45h9V3h1.5v4.5h-3V9H300v1.5h1.5V12H297v-1.5h-1.5V9H294v3Zm3-4.5h3V6h1.5V3H294Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M316.5,12v-1.5H315V9h1.5V4.45H315V3h1.5V1.45h3V3H321V1.45h3V3h1.5v1.5H324V9h1.5v1.5H324V12h-3v-1.5h-1.5V12Zm3-3H321V4.45h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,12v-1.5H339V9h1.5V4.45H339V3h1.5V1.45h3V3H345V1.45h3V3h1.5v1.5H348V9h1.5v1.5H348V12h-3v-1.5h-1.5V12Zm3-3H345V4.45h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,308v-1.5H3V305H4.5v-4.5H3V299H4.5v-1.5h3V299H9v-1.5h3V299h1.5v1.5H12V305h1.5v1.5H12V308H9v-1.5H7.5V308Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M28.5,308v-1.5H27V305h1.5v-4.5H27V299h1.5v-1.5h3V299H33v-1.5h3V299h1.5v1.5H36V305h1.5v1.5H36V308H33v-1.5H31.5V308Zm3-3H33v-4.5H31.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M55.5,306.45v-3h-3V302h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M79.5,306.45v-3h-3V302h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M103.5,306.45v-3h-3V302h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M136.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M148.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M160.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M172.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M184.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M196.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M208.5,303.45V302h9v1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M247.5,306.45v-3h-3V302h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M271.5,306.45v-3h-3V302h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M295.5,306.45v-3h-3V302h3v-3h3v3h3v1.5h-3v3Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M316.5,308v-1.5H315V305h1.5v-4.5H315V299h1.5v-1.5h3V299H321v-1.5h3V299h1.5v1.5H324V305h1.5v1.5H324V308h-3v-1.5h-1.5V308Zm3-3H321v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,308v-1.5H339V305h1.5v-4.5H339V299h1.5v-1.5h3V299H345v-1.5h3V299h1.5v1.5H348V305h1.5v1.5H348V308h-3v-1.5h-1.5V308Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,29.55v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,44v-1.5H3V41H4.5v-4.5H3V35H4.5v-1.5h3V35H9v-1.5h3V35h1.5v1.5H12V41h1.5v1.5H12V44H9v-1.5H7.5V44Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,58.35v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,72.75v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,87.15v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,101.55v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,116v-1.5H3V113H4.5v-4.5H3V107H4.5v-1.5h3V107H9v-1.5h3V107h1.5v1.5H12V113h1.5v1.5H12V116H9v-1.5H7.5V116Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,130.35v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,144.75v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,159.15v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,173.55v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,188v-1.5H3V185H4.5v-4.5H3V179H4.5v-1.5h3V179H9v-1.5h3V179h1.5v1.5H12V185h1.5v1.5H12V188H9v-1.5H7.5V188Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,202.35v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,216.75v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,231.15v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,245.55v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,260v-1.5H3V257H4.5v-4.5H3V251H4.5v-1.5h3V251H9v-1.5h3V251h1.5v1.5H12V257h1.5v1.5H12V260H9v-1.5H7.5V260Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,274.35v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M4.5,288.75v-1.5H3v-1.5H4.5v-4.5H3v-1.5H4.5v-1.5h3v1.5H9v-1.5h3v1.5h1.5v1.5H12v4.5h1.5v1.5H12v1.5H9v-1.5H7.5v1.5Zm3-3H9v-4.5H7.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,29.55v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,44v-1.5H339V41h1.5v-4.5H339V35h1.5v-1.5h3V35H345v-1.5h3V35h1.5v1.5H348V41h1.5v1.5H348V44h-3v-1.5h-1.5V44Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,58.35v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,72.75v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,87.15v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,101.55v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,116v-1.5H339V113h1.5v-4.5H339V107h1.5v-1.5h3V107H345v-1.5h3V107h1.5v1.5H348V113h1.5v1.5H348V116h-3v-1.5h-1.5V116Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,130.35v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,144.75v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,159.15v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,173.55v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,188v-1.5H339V185h1.5v-4.5H339V179h1.5v-1.5h3V179H345v-1.5h3V179h1.5v1.5H348V185h1.5v1.5H348V188h-3v-1.5h-1.5V188Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,202.35v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,216.75v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,231.15v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,245.55v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,260v-1.5H339V257h1.5v-4.5H339V251h1.5v-1.5h3V251H345v-1.5h3V251h1.5v1.5H348V257h1.5v1.5H348V260h-3v-1.5h-1.5V260Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,274.35v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
        <path
          className="cls-2"
          d="M340.5,288.75v-1.5H339v-1.5h1.5v-4.5H339v-1.5h1.5v-1.5h3v1.5H345v-1.5h3v1.5h1.5v1.5H348v4.5h1.5v1.5H348v1.5h-3v-1.5h-1.5v1.5Zm3-3H345v-4.5h-1.5Z"
          transform="translate(-3 -1.45)"
        />
      </StyledFrame>
    </svg>
  );
};

export default LogoMobile;
